import { NavLink as RouterLink } from 'react-router-dom';

import { Link, List, ListItemButton, ListItemText } from '@mui/material';

import type { MenuExtendedItem } from '@components/sidebar/types';

type MenuSubItemProps = {
  items: MenuExtendedItem[];
};

export const MenuSubItems = (props: MenuSubItemProps) => {
  const { items } = props;
  return (
    <List
      component="div"
      disablePadding
      sx={{
        mt: -1,
      }}
    >
      {items.map((item, index) => {
        return (
          <Link
            key={index}
            component={RouterLink}
            underline="none"
            to={item?.link ?? ''}
            sx={{
              mt: 2,
              color: 'inherit',
              '&.active > .MuiButtonBase-root': {
                background: t => t.palette.background.default,
                color: t => t.palette.sidebar.light,
                borderRadius: '4px',
                transition: '0.5s ease ',
              },
            }}
          >
            <ListItemButton
              sx={{ py: 0, my: 1 }}
              disableRipple
            >
              <ListItemText
                primary={item.title}
                sx={{ paddingTop: '2px' }}
              />
            </ListItemButton>
          </Link>
        );
      })}
    </List>
  );
};
